export default __webpack_public_path__ + "locales/vi/Payments.json?hash=1ce5e726311cadac6a19ffa4c25883b2";